export default [
    {
        path: '/receipts',
        name: 'receipt',
        meta: { requiresAuth: true },
        component: () => import('./views/index.vue')
    },
    {
        path: '/receipts/create',
        name: 'receipt-create',
        meta: { requiresAuth: true },
        component: () => import('./views/create.vue')
    }
]